import React from 'react'
import Header from '../Header'

const Gallery = () => {
  return (
    <div>
      <Header/>
      gallery
    </div>
  )
}

export default Gallery